export const iconFontAwesomeHouseholdLightbulb = (
	<i className="fa-solid fa-lightbulb"></i>
);
